// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"styles_sectionHeader__f6U9s","sectionHeaderIcon":"styles_sectionHeaderIcon__WR6iw"};